module.exports = __webpack_public_path__ + "whitefeet.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whitefeet.png
// module id = 886
// module chunks = 0